export default __webpack_public_path__ + "static/streamr-4e80a112ac0c09783735c1b8df5cf2c6.png";